import { FieldArray } from 'react-final-form-arrays';

import { Divider, Typography, Box, Stack, tokens } from '@cast/design-system';

import { PreparedWorkload } from 'features/workload-optimization';

import { getWorkloadConstraints } from '../../../../../_utils';
import { WorkloadConstraintsFieldV2 } from '../../../../../_woop-settings/_components/fields/WorkloadConstraintsFieldV2';
import { VerticalRightsizingPolicyFormModel } from '../../../_types';
import { OverrideGroupOverrideButton } from '../../override/OverrideGroupOverrideButton';
import { OverrideGroupPencilLabel } from '../../override/OverrideGroupPencilLabel';
import { OverrideGroupProvider } from '../../override/OverrideGroupProvider';

import { useControlsGroupState } from '@cast/shared-rff-ui';

export const WorkloadConstraintsSettingsArrayField = ({
  workload,
}: {
  workload: PreparedWorkload;
}) => {
  const { name = '' } = useControlsGroupState({
    name: 'workloadConstraints',
  });

  return (
    <Stack>
      <FieldArray name={name}>
        {({ fields }) =>
          fields.map((name, index) => (
            <Box key={name} data-testid={`container-${index}`}>
              <OverrideGroupProvider
                name={`workloadConstraints[${index}]`}
                canOverride
              >
                <Stack gap={24}>
                  <Typography variant="h6" data-testid="container-name">
                    {workload.containers[index].name}
                  </Typography>
                  <WorkloadConstraintsFieldV2
                    LabelComponent={OverrideGroupPencilLabel}
                  />
                  <OverrideGroupOverrideButton<
                    VerticalRightsizingPolicyFormModel['workloadConstraints'][number]
                  >
                    onRevert={(workload) => ({
                      containerName: workload.containers[index].name,
                      ...getWorkloadConstraints(
                        workload.verticalScalingPolicy?.recommendationPolicies
                      ),
                    })}
                  />
                </Stack>
              </OverrideGroupProvider>

              {fields.length && index < fields.length - 1 && (
                <Divider
                  color={tokens.theme.border.structural.neutralSubtle}
                  sx={{ mt: 12, mb: 24 }}
                />
              )}
            </Box>
          ))
        }
      </FieldArray>
    </Stack>
  );
};
